export const String = "string";
export const Number = "number";
export const DateTime = "dateTime";
export const Date = "date";
export const Boolean = "boolean";
export const Image = "image";
export const ImageFromS3 = "imageFRomS3";
